import { compose, createStore, applyMiddleware, Reducer } from 'redux';
import { ThunkDispatch, withExtraArgument } from 'redux-thunk';

import { reducers } from '../../reducers';
import { IApplicationContext } from '../../types/applicationContext';
import { IApplicationState, IApplicationStateInitial, TReduxActions } from '../../types/redux';

interface IThunkExt {
  dispatch: ThunkDispatch<IApplicationState, IApplicationContext, TReduxActions>;
}

/* istanbul ignore next */
const composeEnhancers = (() => {
  if (process.env.NODE_ENV === 'development' && process.env.IS_BROWSER_BUILD) {
    const { __REDUX_DEVTOOLS_EXTENSION_COMPOSE__ } = window;

    if (__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
      return __REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        name: `dailyrent-search-frontend# ${document.title}`,
        trace: true,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } as any);
    }
  }

  return compose;
})();

/**
 * Хелпер для создания Redux стора
 * @param initialState IApplicationState - предзагруженное состояние
 */
export function createReduxStore(initialState: IApplicationStateInitial, context: IApplicationContext) {
  const storeEnchancers = composeEnhancers(applyMiddleware(withExtraArgument(context)));

  /**
   * В redux 5 `combineReducers` выводит типы состояния, экшенов и предзагруженного состояния
   * сам и больше не принимает их параметрами. Выведенный тип предзагруженного состояния
   * (`never` у веток, чьи редюсеры не объявляют начальное состояние отдельным типом) с
   * `IApplicationStateInitial` не пересекается, поэтому форму стора задаём здесь явно.
   * Форму состояния сверяет `satisfies TReducersMap<IApplicationState, ...>` у карты
   * редюсеров, приведение закрывает только тип предзагруженного состояния.
   */
  return createStore<IApplicationState, TReduxActions, IThunkExt, {}, IApplicationStateInitial>(
    reducers as unknown as Reducer<IApplicationState, TReduxActions, IApplicationStateInitial>,
    initialState,
    storeEnchancers,
  );
}
